import React from "react";

// * Import 3rd party lib
import { styled, useTheme } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";

// * Import custom components
import Logo from "../../components/Logo/Logo";

// * Import Images
import logo from "../../../assets/images/MJN_logo_RGB.svg";
import darkThemeLogo from "../../../assets/images/dark_theme/MJN_logo_RGB_White.svg";
import UserInfo from "../../components/UserInfo/UserInfo";
import { useDispatch, useSelector } from "react-redux";
import { getThemeName } from "../../utils/utils";
import Icon from "../../components/Icon";
import { updateUserJourney } from "../../redux/slice/authSlice";

// * Define required styled components
const Root = styled(Box)(({ theme }) => ({
  overflow: "hidden",
  paddingLeft: theme.sizeRem[1],
  paddingRight: theme.sizeRem[1],
  height: "100%",
  background: theme.palette.header.main,
}));

function Header(props = {}) {
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);
  const theme = useTheme();
  const dispatch = useDispatch();
  const urlPath = window.location.pathname;

  const isQuickTourDisabled = () => {
    if (
      urlPath.includes("discover") ||
      urlPath.includes("assist") ||
      urlPath.includes("account-setup")
    ) {
      return false;
    }
    return true;
  };

  return (
    <Root>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ height: "100%"}}
        spacing={2}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ height: "100%" }}
          spacing={2}
        >
          <Logo logo={getThemeName(isDarkMode) ? darkThemeLogo : logo} />
        </Stack>

        <Box
          sx={{
            paddingLeft: theme.size[10],
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <Root>
              <Icon
                iconName="tour"
                className="material-icons-outlined"
                title="Quick Tour"
                disabled={isQuickTourDisabled()}
                onClick={() => {
                  dispatch(updateUserJourney(true));
                }}
                sx={{
                  fontSize: theme.size[26],
                  width: theme.size[26],
                  height: "auto",
                  cursor: "pointer",
                  fontWeight: theme.fontWeight[500],
                  color: theme.palette.cards.heading,
                  "&:hover": {
                    color: theme.palette.cards.heading,
                  },
                  marginLeft: theme.size[6],
                }}
              />
            </Root>
          </Box>
          <UserInfo />
        </Box>
      </Stack>
    </Root>
  );
}

export default Header;
